var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 content-card py-3"},[_c('faq-form',{attrs:{"entity":_vm.entity},on:{"submit":_vm.onSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }